import React, { Component, useRef } from "react";

import { Alert } from "@material-ui/lab";

import {
  Grid,
  Typography,
  TextField,
  Button,
  // Link,
  Box,
  Snackbar,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  forgetUser,
  clearStore,
  resetPasswordForgot,
} from "../../store/actions";
// import logodark from "../../assets/images/logo-main.jpg";
import logodark from "../../assets/images/Expanded_Colored_PoweredBy.png";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Input from "@material-ui/core/Input";
import { OutlinedInput } from "@material-ui/core";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useLocation } from "react-router-dom";
import { BackgroundPattern } from "../../components/BackgroundPattern";
import EncryptPassword from "../../components/EncryptPassword";

const styles = (theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(2),
    position: "relative",
    overflowX: "hidden",
    overflowY: "auto",
  },
  background: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: -1,
    animation: "$animateBackground 10s infinite",
  },
  "@keyframes animateBackground": {
    "0%": {
      transform: "translateX(-100%)",
    },
    "100%": {
      transform: "translateX(100%)",
    },
  },
  overlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    background: "rgba(0, 0, 0, 0)",
  },
  container: {
    position: "relative",
    zIndex: 1,
    justifyContent: "space-evenly",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
  },
  form: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(4),
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[3],
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(3, 2),
    },
  },
  title: {
    marginBottom: theme.spacing(1),
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  spamHint: {
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(0.5, 1),
    "& .MuiAlert-icon": {
      padding: theme.spacing(0.5, 0),
      fontSize: "1.1rem",
      marginRight: theme.spacing(1),
    },
    "& .MuiAlert-message": {
      padding: theme.spacing(0.5, 0),
      fontSize: "0.75rem",
      lineHeight: 1.4,
    },
  },
  otpRow: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      gap: theme.spacing(0.5),
    },
  },
  otpInput: {
    width: 48,
    [theme.breakpoints.down("xs")]: {
      width: 40,
    },
    "& .MuiOutlinedInput-input": {
      textAlign: "center",
      fontSize: "1.15rem",
      fontWeight: 600,
      padding: theme.spacing(1.5, 0.5),
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 1),
    textTransform: "none",
    fontWeight: 600,
    padding: theme.spacing(1.25, 2),
  },
  textButton: {
    textTransform: "none",
  },
});

const PasswordResetPage = (props) => {
  console.log("props: ", props);
  const { classes } = props;
  const location = useLocation();
  const { state } = location;
  let email;
  if (state && state.email) {
    email = state.email;
    // Do something with the passed email value
    // console.log("Received Email:", email);
  }
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [step, setStep] = useState(1);

  const [verificationCode, setVerificationCode] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);
  const verificationCodeRefs = useRef([]);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [passwordError1, setPasswordError1] = useState(false);
  const [passwordErrorBoth, setPasswordErrorBoth] = useState(false);
  const [detailedErr, setDetailedErr] = useState("");
  const [submit, setSubmit] = useState(false);
  const [verificationCodeEntered, setVerificationCodeEntered] = useState(false);
  const reset = useSelector((state) => {
    return state.forgetPassword;
  });
  var success = false;
  const { loading, resetSuccess, resetError } = reset;
  
  const regex = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{8,}$/;
  const dispatch = useDispatch();

  //reset error in here

  // function handleSubmit() {
  //   //check equal and not empty and whatever other requirements
  // }

  // function handleChangePassword(){
  //     setPassword1(password)
  // }
  function handleClickShowPassword1() {
    setShowPassword1(!showPassword1);
  }
  function handleClickShowPassword2() {
    setShowPassword2(!showPassword2);
  }
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const focusCodeInput = (index) => {
    const node = verificationCodeRefs.current[index];
    if (node) {
      node.focus();
    }
  };

  const handleDigitChange = (index, event) => {
    const raw = event.target.value.replace(/\D/g, "");

    if (raw.length > 1) {
      const updatedVerificationCode = [...verificationCode];
      raw.slice(0, 6 - index).split("").forEach((digit, offset) => {
        updatedVerificationCode[index + offset] = digit;
      });
      setVerificationCode(updatedVerificationCode);
      focusCodeInput(Math.min(index + raw.length, 5));
      return;
    }

    const value = raw.slice(-1);
    const updatedVerificationCode = [...verificationCode];
    updatedVerificationCode[index] = value;
    setVerificationCode(updatedVerificationCode);

    if (value && index < 5) {
      focusCodeInput(index + 1);
    }
  };

  const handleDigitKeyDown = (index, event) => {
    if (event.key === "Backspace" && !verificationCode[index] && index > 0) {
      focusCodeInput(index - 1);
    }
  };

  const handleDigitPaste = (event) => {
    event.preventDefault();
    const pasted = event.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!pasted) {
      return;
    }
    const updatedVerificationCode = [...verificationCode];
    pasted.split("").forEach((digit, offset) => {
      updatedVerificationCode[offset] = digit;
    });
    setVerificationCode(updatedVerificationCode);
    focusCodeInput(Math.min(pasted.length, 5));
  };

  const handleContinueToPassword = () => {
    if (verificationCodeEntered) {
      setStep(2);
    }
  };

  const handleBackToCode = () => {
    setStep(1);
  };

  useEffect(() => {
    setSubmit(false);
    if (password1 != "") {
      if (!regex.test(password1)) {
        setPasswordError1(true);
        setDetailedErr(
          "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
        );
      } else if (password1 != password2) {
        setPasswordError1(true);
        setDetailedErr("Passwords don't match!");
      } else {
        setPasswordError1(false);
      }
    }
  }, [password1]);

  useEffect(() => {
    setSubmit(false);
    if (password2 != "") {
      if (password1 != password2) {
        setPasswordError1(true);
        setDetailedErr("Passwords don't match!");
      } else {
        setPasswordError1(false);
        setSubmit(true);
      }
    }
  }, [password2]);

  useEffect(() => {
    // console.log("verificationCode=", verificationCode);
    const isEntered = verificationCode.every((digit) => /^\d$/.test(digit));
    // console.log("isEntered: " + isEntered);
    setVerificationCodeEntered(isEntered);
  }, [verificationCode]);

  // function handleSubmit() {
  //   dispatch(resetPasswordForgot({ password: password1, token: token.token }));
  // }
  async function handleSubmit() {
    const encryptedPassword = await EncryptPassword(password1);
    const newUser = {
      password: encryptedPassword,
      verificationcode: JSON.stringify(verificationCode).replace(/[^0-9]/g, ''),
      username: email,
    };
    console.log("New User :: ", newUser);
    console.log(
      "Handle Submit :: ",
      password1,
      "verification :: ",
      verificationCode,
      "username :: ",
      email
    );
    dispatch(resetPasswordForgot(newUser));
  }
  useEffect(() => {
    if (resetSuccess) {
      success = true;
      clearStore();
    } else {
      success = false;
    }
  }, [resetSuccess]);

  useEffect(() => {
    if (!resetError) {
      return;
    }
    setPassword1("");
    setPassword2("");
    setDetailedErr(resetError);
    setStep(1);
    console.log("reseterr", resetError);
  }, [resetError]);

  if (resetSuccess) {
    return (
      <div className={`${classes.root}`}>
        <div className={`${classes.background}`}></div>
        <Grid container component="main" className={classes.container}>
          <Grid item xs={12} sm={8} md={5} lg={4}>
            <div className={classes.logo}>
              <Link to="/" className="logo">
                <img src={logodark} height="60" alt="logo" />
              </Link>
            </div>

            <Snackbar open={true}>
              <Alert severity="success">Password Changed Successfully!</Alert>
            </Snackbar>

            <Box mt={2} textAlign="center">
              <Typography variant="body2">
                Return to{" "}
                <Link to="/login" color="primary">
                  Login Page
                </Link>
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <BackgroundPattern />
      </div>
    );
  } else {
    return (
      <div className={`${classes.root}`}>
        <div className={`${classes.background}`}></div>
        <Grid container component="main" className={classes.container}>
          <Grid item xs={12} sm={8} md={5} lg={4}>
            <div className={classes.form}>
              <div className={classes.logo}>
                <Link to="/" className="logo">
                  <img src={logodark} height="60" alt="logo" />
                </Link>
              </div>
              <Typography
                component="h1"
                variant="h5"
                align="center"
                className={classes.title}
              >
                Reset your password to CloudCatcher!
              </Typography>
              <Typography
                variant="body2"
                align="center"
                className={classes.subtitle}
              >
                {step === 1
                  ? "Enter verification code that you received on your email account!"
                  : "Enter and confirm your new password."}
              </Typography>

              <AvForm
                onSubmit={(event) => {
                  event.preventDefault();
                  if (step === 1) {
                    handleContinueToPassword();
                    return;
                  }
                  if (verificationCodeEntered && submit && !loading) {
                    handleSubmit();
                  }
                }}
              >
                {step === 1 && (
                  <>
                    <div className={classes.otpRow}>
                      {[0, 1, 2, 3, 4, 5].map((index) => (
                        <TextField
                          key={index}
                          inputRef={(ref) =>
                            (verificationCodeRefs.current[index] = ref)
                          }
                          variant="outlined"
                          className={classes.otpInput}
                          value={verificationCode[index]}
                          onChange={(event) => handleDigitChange(index, event)}
                          onKeyDown={(event) => handleDigitKeyDown(index, event)}
                          onPaste={handleDigitPaste}
                          inputProps={{
                            maxLength: 1,
                            inputMode: "numeric",
                            autoComplete: index === 0 ? "one-time-code" : "off",
                            "aria-label": `Verification code digit ${index + 1}`,
                          }}
                        />
                      ))}
                    </div>
                    <Alert severity="info" className={classes.spamHint}>
                      If you have not received the email within 15 minutes, please check your spam folder before contacting CloudCatcher Support.
                    </Alert>
                    {resetError ? (
                      <Alert severity="error" className="mt-2">
                        {resetError}
                      </Alert>
                    ) : null}
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                      type="submit"
                      disabled={!verificationCodeEntered}
                    >
                      Continue
                    </Button>
                  </>
                )}

                {step === 2 && (
                  <>
                    <TextField
                      label="Enter password"
                      variant="outlined"
                      fullWidth
                      type={showPassword1 ? "text" : "password"}
                      onChange={(e) => setPassword1(e.target.value)}
                      value={password1}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleClickShowPassword1}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword1 ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <Box mt={2}>
                      <TextField
                        label="Confirm Password"
                        variant="outlined"
                        fullWidth
                        type={showPassword2 ? "text" : "password"}
                        onChange={(e) => setPassword2(e.target.value)}
                        value={password2}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleClickShowPassword2}
                                onMouseDown={handleMouseDownPassword}
                              >
                                {showPassword2 ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                    <div>
                      {passwordError1 ? (
                        <Alert severity="error" className="mt-4">
                          {detailedErr}
                          {/* ,
                                  {this.props.handleError()} */}
                        </Alert>
                      ) : null}
                    </div>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                      type="submit"
                      disabled={!verificationCodeEntered || !submit || loading}
                    >
                      {loading ? "Resetting..." : "Reset Password"}
                    </Button>
                    <Box textAlign="center">
                      <Button
                        color="primary"
                        className={classes.textButton}
                        type="button"
                        onClick={handleBackToCode}
                      >
                        Change verification code
                      </Button>
                    </Box>
                  </>
                )}
              </AvForm>
              <Box mt={2} textAlign="center">
                <Typography variant="body2">
                  Return to{" "}
                  <Link to="/login" color="primary">
                    Login Page
                  </Link>
                </Typography>
              </Box>
            </div>
          </Grid>
        </Grid>
        <BackgroundPattern />
      </div>
    );
  }
};

export default withStyles(styles)(PasswordResetPage);
